import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { IoClose, IoWarning } from "react-icons/io5";
import "../css/gallery.scss";
import "../css/items.scss";
import { serverInstance } from "../service/axios";
import Dimmer from "./shared/Dimmer";

const Gallery = ({ data }) => {

  const [collapsedAlbums, setCollapsedAlbums] = useState({});
  const [albumsAll, setAlbumsAll] = useState({});
  const [albums, setAlbums] = useState({});
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [currentAlbumName, setCurrentAlbumName] = useState("");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedAlbumId, setSelectedAlbumId] = useState(null);
  const ITEMS_PER_PAGE = 12;

  useEffect(() => {
    AOS.init();
    loadAlbums();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    registerOnClicks();
  }, [selectedAlbumId]);

  const registerOnClicks = () => {
    const handleKeyPress = (e) => {
      if (selectedAlbumId) {
        if (e.key === 'ArrowLeft') {
          handlePrevImage();
        } else if (e.key === 'ArrowRight') {
          handleNextImage();
        } else if (e.key === 'Escape') {
          closeSlider();
        }
      }
    };
  
    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  };

  const loadAlbums = () => {
    serverInstance.get("/app/photos")
      .then(res => {
        setAlbumsAll(res.data.items)
        initAlbums(res.data.items);
        setErrorMsg("");
        setLoading(false);
      })
      .catch((err) => {
        setErrorMsg(err);
        setLoading(false);
      })
  };

  const initAlbums = (albums) => {
    let temp = {};
    for (const albumId in albums) {
      let photos = albums[albumId];
      let photosToShow = photos.slice(0, Math.min(photos.length, ITEMS_PER_PAGE));
      temp[albumId] = photosToShow;
    }
    setAlbums(temp);
  }

  const loadMorePhotos = (albumId) => {
    let allPhotos = albumsAll[albumId];
    if (allPhotos.length > albums[albumId].length) {
      let temp = {...albums};
      temp[albumId] = allPhotos.slice(0, albums[albumId].length + ITEMS_PER_PAGE);
      setAlbums(temp);
    }
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) => 
      prev === 0 ? albumsAll[selectedAlbumId].length - 1 : prev - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) => 
      prev === albumsAll[selectedAlbumId].length - 1 ? 0 : prev + 1
    );
  };

  const openImage = (albumId, index) => {
    setSelectedAlbumId(albumId);
    setCurrentImageIndex(index);
    setCurrentAlbumName(albumsAll[albumId][0].album_name);
  };

  const closeSlider = () => {
    setSelectedAlbumId(null);
    setCurrentImageIndex(0);
  }

  const toggleAlbum = (albumId) => {
    setCollapsedAlbums(prev => ({
      ...prev,
      [albumId]: !prev[albumId]
    }));
  };

  return (
    <div className="gallery items-container" id="gallery">
     <div className="upper-section">
        <div className="upper-section-inner">
          <div className="title-container">
            <h2>{data.title}</h2>
          </div>
        </div>
      </div>

      {loading ? <Dimmer/> : null}

      {errorMsg ? <div className="error-msg">
        <IoWarning/>
        &nbsp;
        {errorMsg}
      </div> : null}

      {albums ?
      Object.entries(albums).map(([albumId, images]) => {
        return (
          <div className="images-container" key={albumId}>
            <div className={`album-title ${collapsedAlbums[albumId] ? 'collapsed' : ''}`}
              onClick={() => toggleAlbum(albumId)}
              style={{ cursor: 'pointer' }}
            >
              {images[0]?.album_name}
            </div>

            <div style={{ display: collapsedAlbums[albumId] ? 'none' : 'block' }}>
              <div className="image-container">
                {images.map((image, index) => {
                  return (
                    <div className="img-container" key={image.id}>
                      <img 
                        src={`https://lingo-portal-assets.s3.ap-northeast-2.amazonaws.com/${image.fileUrl}`} 
                        className="image" 
                        onClick={() => openImage(albumId, index)}
                      />
                      <p className="image-text">
                        {image.text}
                      </p>
                    </div>
                  );
                })}
              </div>
              <div className="more">
                <button onClick={() => loadMorePhotos(albumId)}>{data.more}</button>
              </div>
            </div>
          </div>
        );
      })
      :
      <div className='d-flex justify-content-center w-100'>
        {data.noData}
      </div>
      }

      {selectedAlbumId && albumsAll[selectedAlbumId] && (
        <div className="slider-container">
          <div className="slider-header">
            <span>{currentAlbumName}</span>
            <button 
              className="close-button" 
              onClick={() => closeSlider()}
            >
            <IoClose />
            </button>
          </div>
          <div className="main-image-container">
            <button className="nav-button prev" onClick={handlePrevImage}>
              <IoIosArrowBack />
            </button>
            <img 
              src={`https://lingo-portal-assets.s3.ap-northeast-2.amazonaws.com/${albumsAll[selectedAlbumId][currentImageIndex].fileUrl}`}
              alt={albumsAll[selectedAlbumId][currentImageIndex].text}
              className="main-image"
            />
            <button className="nav-button next" onClick={handleNextImage}>
              <IoIosArrowForward />
            </button>
          </div>
          
          <div className="thumbnail-slider">
            {albumsAll[selectedAlbumId].map((image, index) => (
              <img
                key={image.id}
                src={`https://lingo-portal-assets.s3.ap-northeast-2.amazonaws.com/${image.fileUrl}`}
                alt={image.text}
                className={`thumbnail ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => setCurrentImageIndex(index)}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
export default Gallery;
